import axios from "axios";

import { CONSTANTS } from "./constant";
import { useNavigate } from "react-router-dom"; // Use `useNavigate` instead of `useHistory`
import { useEffect } from "react";

export const PublicAxiosInstance = axios.create({
  baseURL: CONSTANTS?.BACKEND_URL_PUBLIC,
});

export const PrivateAxiosInstance = axios.create({
  baseURL: CONSTANTS?.BACKEND_URL,
});

export const AxiosAuthInstance = axios.create({
  baseURL: CONSTANTS?.BACKEND_URL_AUTH,
});

export const ConfigurePrivateAxiosInstance = (AUTH_TOKEN) => {
  PrivateAxiosInstance.defaults.headers.common["Authorization"] = AUTH_TOKEN;
};

// Interceptor to handle session expiration
const setupInterceptor = (axiosInstance, navigate) => {
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 440) {
        // or whatever status code indicates session expiration
        // Clear local storage
        localStorage.clear();

        // Redirect to login page
        navigate("/auth/sign-in");
      }
      return Promise.reject(error);
    }
  );

  // Request interceptor to attach Authorization header from localStorage
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("userData");
      if (token?.token) {
        config.headers["Authorization"] = `${token?.token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

export const useAxiosInterceptors = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setupInterceptor(PrivateAxiosInstance, navigate);
    setupInterceptor(AxiosAuthInstance, navigate);
  }, [navigate]);
};
